import { render, staticRenderFns } from "./grup13.vue?vue&type=template&id=3d9f1d17&scoped=true&"
import script from "./grup13.vue?vue&type=script&lang=js&"
export * from "./grup13.vue?vue&type=script&lang=js&"
import style0 from "./grup13.vue?vue&type=style&index=0&id=3d9f1d17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f1d17",
  null
  
)

export default component.exports